module.exports = __webpack_public_path__ + "img/octi-logo.9e1bc260.svg";